<div class="copilot-message-container" *ngIf="data">
  <div class="copilot-message-content">
    <highcharts-chart
                      [Highcharts]="Highcharts"
                      [options]="chartOptions"
                      style="height: 464px;"
    ></highcharts-chart>
  </div>
</div>
